import deJson from './de.json';
import elJson from './el.json';
import enJson from './en.json';
import engbJson from './en-gb.json';
import esJson from './es.json';
import escoJson from './es-co.json';
import esmxJson from './es-mx.json';
import frJson from './fr.json';
import frCaJson from './fr-ca.json';
import idJson from './id.json';
import itJson from './it.json';
import jaJson from './ja.json';
import koJson from './ko.json';
import nlJson from './nl.json';
import noJson from './no.json';
import plJson from './pl.json';
import pseudoJson from './pseudo.json';
import ptbrJson from './pt-br.json';
import ruJson from './ru.json';
import svJson from './sv.json';
import thJson from './th.json';
import trJson from './tr.json';
import viJson from './vi.json';
import zhcnJson from './zh-cn.json';
import zhhkJson from './zh-hk.json';


 
export default {
  translations: {
    'de': deJson,
    'el': elJson,
    'el-gr': elJson,
    'en': enJson,
    'en-gb': engbJson,
    'es-co': escoJson,
    'en-us': enJson,
    'es': esJson,
    'es-mx': esmxJson,
    'fr': frJson,
    'fr-fr': frJson,
    'fr-ca': frCaJson,
    'id': idJson,
    'it': itJson,
    'ja': jaJson,
    'ko': koJson,
    'nl': nlJson,
    'no': noJson,
    'no-no': noJson,
    'pl': plJson,
    'pt-br': ptbrJson,
    'ru': ruJson,
    'sv': svJson,
    'sv-se': svJson,
    'th': thJson,
    'th-th': thJson,
    'tr': trJson,
    'vi': viJson,
    'vi-vn': viJson,
    'ts': pseudoJson,
    'zh-cn': zhcnJson,
    'zh-hk': zhhkJson
  }
};
